(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description-toggle"] && !Shopify.designMode) return;
  try {
    window.initDescriptionToggle = function() {
    const toggleButton = document.getElementById('descriptionToggle');

    if (toggleButton) {
      toggleButton.addEventListener('click', function() {
        const preview = document.querySelector('.product-description__preview');
        const full = document.querySelector('.product-description__full');
        const readMore = this.querySelector('.read-more');
        const readLess = this.querySelector('.read-less');

        if (full.style.display === 'none') {
          // Show full description
          preview.style.display = 'none';
          full.style.display = 'block';
          readMore.style.display = 'none';
          readLess.style.display = 'inline';
        } else {
          // Show preview
          preview.style.display = 'block';
          full.style.display = 'none';
          readMore.style.display = 'inline';
          readLess.style.display = 'none';
        }
      });
    }
  };

  // Auto-initialize if DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initDescriptionToggle);
  } else {
    window.initDescriptionToggle();
  }
  } catch(e) { console.error(e); }
})();

})();
